export const gridPlaceholderText = '__defaultGridPlaceholder__'
